/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : githubIntegrationAction.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
const { default: actionType } = require("../actionTypes");

const githubIntegrationAction = {
  get_git_swm_logs: {
    api_name: "/VLC/github_integration/logs/swm/view",
    https_method: "GET",
    action_type: actionType.GET_GIT_SWM_LOGS,
    description: "Get the Git Software Modules logs",
  },
  approve_git_swm_logs: {
    api_name: "/VLC/github_integration/logs/swm/approve",
    https_method: "PUT",
    action_type: actionType.APPROVE_GIT_SWM_LOGS,
    description: "Approve the Git Software Modules logs",
  },
};

module.exports = githubIntegrationAction;
